import React from 'react';
import './AdminPill.css';

/**
 * @param {{
 *   tone?: 'critical' | 'signal' | 'ambient' | 'ok' | 'neutral',
 *   children?: React.ReactNode,
 *   className?: string
 * }} props
 */
function AdminPill({ tone = 'neutral', children, className = '' }) {
  return (
    <span className={`au-pill au-scope au-pill--${tone}${className ? ` ${className}` : ''}`}>
      <span className="au-pill__dot" aria-hidden="true" />
      <span className="au-pill__label">{children}</span>
    </span>
  );
}

export default AdminPill;
